import {
  useGetAllowedTokensParameterGroupQuery,
  useGetCustomerGroupParameterGroupQuery,
  useGetDomicileClassParameterGroupQuery,
  useGetProductGroupParameterGroupQuery,
  useGetSalesChannelParameterGroupQuery
} from 'Services/ProductManagement/Features/Parameter/parameterApi'
import { useEffect, useState } from 'react'
import { useSearchParams } from 'react-router-dom'

const SELECTED_PARAMETER_KEY = 'selectedParameter'

function useParameterGroups() {
  const [searchParams, setSearchParams] = useSearchParams()

  const selectedParameterQueryParam = searchParams.get(SELECTED_PARAMETER_KEY) ?? undefined
  const [selectedParameterId, setSelectedParameterId] = useState(selectedParameterQueryParam)

  const {
    data: productGroupParameterGroup = null,
    refetch: fetchProductGroups,
    isLoading: productGroupParameterGroupLoading,
    isFetching: productGroupParameterGroupFetching
  } = useGetProductGroupParameterGroupQuery(undefined)

  const {
    data: customerGroupParameterGroup = null,
    refetch: fetchCustomerGroups,
    isLoading: customerGroupParameterGroupLoading,
    isFetching: customerGroupParameterGroupFetching
  } = useGetCustomerGroupParameterGroupQuery(undefined)

  const {
    data: salesChannelParameterGroup = null,
    refetch: fetchSalesChannels,
    isLoading: salesChannelParameterGroupLoading,
    isFetching: salesChannelParameterGroupFetching
  } = useGetSalesChannelParameterGroupQuery(undefined)

  const {
    data: domicileClassParameterGroup = null,
    refetch: fetchDomicileClasses,
    isLoading: domicileClassParameterGroupLoading,
    isFetching: domicileClassParameterGroupFetching
  } = useGetDomicileClassParameterGroupQuery(undefined)

  const {
    data: allowedTokensParameterGroup = null,
    refetch: fetchAllowedTokens,
    isLoading: allowedTokensParameterGroupLoading,
    isFetching: allowedTokensParameterGroupFetching
  } = useGetAllowedTokensParameterGroupQuery(undefined)

  useEffect(() => {
    if (selectedParameterId) {
      selectedParameterId && searchParams.set(SELECTED_PARAMETER_KEY, selectedParameterId)
      setSearchParams(searchParams)
    } else {
      searchParams.delete(SELECTED_PARAMETER_KEY)
      setSearchParams(searchParams)
    }
  }, [selectedParameterId])

  return {
    productGroupParameterGroup,
    isProductGroupParameterGroupLoading:
      productGroupParameterGroupLoading || productGroupParameterGroupFetching,
    customerGroupParameterGroup,
    isCustomerGroupParameterGroupLoading:
      customerGroupParameterGroupLoading || customerGroupParameterGroupFetching,
    salesChannelParameterGroup,
    isSalesChannelParameterGroupLoading:
      salesChannelParameterGroupLoading || salesChannelParameterGroupFetching,
    domicileClassParameterGroup,
    isDomicileClassParameterGroupLoading:
      domicileClassParameterGroupLoading || domicileClassParameterGroupFetching,
    allowedTokensParameterGroup,
    isAllowedTokensParameterGroupLoading:
      allowedTokensParameterGroupLoading || allowedTokensParameterGroupFetching,
    fetchProductGroups,
    fetchCustomerGroups,
    fetchSalesChannels,
    fetchDomicileClasses,
    fetchAllowedTokens,
    selectedParameterId,
    setSelectedParameterId
  }
}

export default useParameterGroups
